module.exports = "/_next/static/images/top-c600a6a2373b439dff2c693e6d8c415c.jpg";